import React from "react";
import "./style.scss";
import ZaufanieRadom from "./hooksZaufanie/radomJump";
import ZaufanieWarszawa from "./hooksZaufanie/warszawaJump";
import LoadableComponent from "../../../features/Loading/LoadableComponent";
import useConfirmationData from "./useConfirmationData";
import { useSelector } from "react-redux";
import { State } from "../../store";
import { useTranslation } from "react-i18next";
import { HiOutlineDownload, HiOutlineTicket } from "react-icons/hi";

const PurchaseSuccess: React.FC = () => {
  const { loading, confirmationData, getConfirmationDocument, getConfirmationTickets, facilityIds, billKey } =
    useConfirmationData();
  const { t } = useTranslation();
  const startPageUrl = useSelector((state: State) => state.config.configuration.startPageUrl);
  const messageSummary = useSelector((state: State) => state.config.configuration.message_summary);

  return (
    <div className="purchase-complited">
      <LoadableComponent loading={loading}>
        <div className="purchase-complited-start">
          <h1>{t("platnosc_przebiegla_pomyslnie")}</h1>
          <p>{t("twoje_bilety_powinny_pojawic_sie_wkrotce_na_adresie_email")}</p>
          {messageSummary && (
            <React.Fragment>
              {messageSummary.length > 12 ? (
                <div className="alert alert-comment">
                  <article dangerouslySetInnerHTML={{ __html: messageSummary }}></article>
                </div>
              ) : (
                <p></p>
              )}
            </React.Fragment>
          )}
          <div className="flex-start-center purchase-complited-buttons">
            {confirmationData.containsTickets && (
              <button
                className="button medium padding-medium button-fill-background-main"
                onClick={() => getConfirmationTickets()}
              >
                {t("pobierz_bilety")} (PDF) <HiOutlineTicket className="icon" />
              </button>
            )}
            {confirmationData.containsInvoice && (
              <button
                className="button medium padding-medium button-fill-background-main"
                onClick={() => getConfirmationDocument()}
              >
                {t("pobierz_potwierdzenie")}
                <HiOutlineDownload className="icon" />
              </button>
            )}
          </div>
          <div className="continue_button">
            <a className="button button-fill-main medium padding-medium" target="_parent" href={startPageUrl}>
              {t("zacznij_zakupy_od_nowa")}
            </a>
          </div>

          {/* <ConfettiAnimation /> */}
        </div>
      </LoadableComponent>

      {/* 
      <div className="block shadow flex-center-center flex-wrap">
        <div className="success-purchase-icon flex-center-center">
          <TbConfetti className="icon" />
        </div>
        */}
      {/* <h1>{t("platnosc_przebiegla_pomyslnie")}</h1>
        <p>{t("juz_lada_moment_bilety_powinny_znalezc_sie_na_twoim_mailu")}</p> */}
      {/* <b>{billKey}</b> */}
      {/* <p className="mailInfo">{confirmationData.email}</p> */}
      {facilityIds === "1200" && (
        <React.Fragment>
          <ZaufanieRadom />
        </React.Fragment>
      )}
      {facilityIds === "1204" && (
        <React.Fragment>
          <ZaufanieWarszawa />
        </React.Fragment>
      )}
      {/* <div className=""></div> */}
      {/* <div className="flex-start-center">
          <button className="button button-fill-background-main medium padding-medium">
            Pobierz bilety(PDF)
            <HiOutlineDownload className="icon" />
          </button>

          <button className="button button-fill-background-main medium padding-medium">
            Pobierz dokument <HiOutlineDownload className="icon" />
          </button>
          <button className="button button-fill-background-main medium padding-medium">
            Pobierz fakturę <HiOutlineDownload className="icon" />
          </button>
        </div> */}

      {/* <LoadableComponent loading={loading}>
          <div className="button-group">
            <div className="button-group-first-row">
              {confirmationData.containsInvoice && (
                <button onClick={() => getConfirmationDocument()}>{t("pobierz_potwierdzenie")}</button>
              )}
              {confirmationData.containsTickets && (
                <button onClick={() => getConfirmationTickets()}>{t("pobierz_bilety")}</button>
              )}
            </div>
            <div className="button-group-second-row"> */}
      {/* <button onClick={() => navigate(SALE_MOVIE_PAGE)}>Zacznij zakupy od nowa</button> */}
      {/* <a className="button button-fill-main medium padding-medium" target="_parent" href={startPageUrl}>
                {t("zacznij_zakupy_od_nowa")}
              </a>
            </div>
          </div>
        </LoadableComponent>
      </div> */}
    </div>
  );
};

export default PurchaseSuccess;
